module.exports = __webpack_public_path__ + "site/img/honor.dd44264.png";


//////////////////
// WEBPACK FOOTER
// ./site/honor.png
// module id = 106
// module chunks = 1